import { addDays, subDays } from 'date-fns';
import { generateId } from '../utils/id';
import { getDateKey } from '../utils/date';
import type { Habit } from '../types/habit';
import type { Task } from '../types/task';
import type { BorrowedItem } from '../types/borrowedItem';

function daysAgoKey(n: number): string {
  return getDateKey(subDays(new Date(), n));
}

function daysAgoISO(n: number): string {
  return subDays(new Date(), n).toISOString();
}

function daysFromNowISO(n: number, hour = 9): string {
  const date = addDays(new Date(), n);
  date.setHours(hour, 0, 0, 0);
  return date.toISOString();
}

export function buildSeedHabits(): Habit[] {
  return [
    {
      id: generateId(),
      name: 'Drink 8 glasses of water',
      createdAt: daysAgoISO(10),
      completions: [daysAgoKey(1), daysAgoKey(2), daysAgoKey(3), daysAgoKey(4)],
    },
    {
      id: generateId(),
      name: 'Read for 20 minutes',
      createdAt: daysAgoISO(10),
      completions: [daysAgoKey(1), daysAgoKey(4)],
    },
    {
      id: generateId(),
      name: 'Exercise',
      createdAt: daysAgoISO(10),
      completions: [daysAgoKey(2), daysAgoKey(3), daysAgoKey(4), daysAgoKey(5)],
    },
  ];
}

export function buildSeedTasks(): Task[] {
  return [
    {
      id: generateId(),
      title: 'Submit expense report',
      deadline: daysFromNowISO(0, 17),
      reminder: true,
      completed: false,
      createdAt: daysAgoISO(3),
    },
    {
      id: generateId(),
      title: 'Call the dentist to reschedule',
      deadline: daysFromNowISO(1, 10),
      reminder: false,
      completed: false,
      createdAt: daysAgoISO(2),
    },
    {
      id: generateId(),
      title: 'Pay electricity bill',
      deadline: daysFromNowISO(3, 9),
      reminder: true,
      completed: false,
      createdAt: daysAgoISO(1),
    },
    {
      id: generateId(),
      title: 'Finish quarterly slides',
      deadline: daysFromNowISO(-1, 18),
      reminder: true,
      completed: false,
      createdAt: daysAgoISO(5),
    },
  ];
}

export function buildSeedBorrowedItems(): BorrowedItem[] {
  return [
    {
      id: generateId(),
      itemName: 'Atomic Habits (book)',
      borrowedTo: 'Sam',
      dateBorrowed: daysAgoISO(6),
      returnDeadline: daysFromNowISO(2),
      returned: false,
    },
    {
      id: generateId(),
      itemName: 'Cordless drill',
      borrowedTo: 'Alex next door',
      dateBorrowed: daysAgoISO(14),
      returnDeadline: daysAgoISO(2),
      returned: false,
    },
    {
      id: generateId(),
      itemName: 'Board game - Catan',
      borrowedTo: 'Jordan',
      dateBorrowed: daysAgoISO(20),
      returnDeadline: daysAgoISO(10),
      returned: true,
      returnedAt: daysAgoISO(9),
    },
  ];
}
